import TabsComponent from "@/components/TabsComponent"
import AdminLayout from "@/layouts/AdminLayout"

const Candidates = () => {
  return (
    <AdminLayout>
      <TabsComponent />
    </AdminLayout>
  )
}

export default Candidates